// Lógica compartida del paso "Mis datos" de la inscripción de pregrado.
// La usan el formulario actual (InscripcionAgregarMisDatos) y el rediseñado (v2/PasoMisDatos),
// para no tener dos copias de la validación de identificación ni del autollenado.
import { consulta, generarFiltros } from "../../global/js/funciones";

// Fecha en formato AAAA-MM-DD con la hora local (toISOString la pasa a UTC y, después de las
// 7:00 p. m. en Colombia, la corre un día; eso rompería la verificación con la fecha de expedición).
export function formatoFecha(fecha) {
  if (!fecha) return "";
  const d = new Date(fecha);
  if (isNaN(d.getTime())) return "";
  const dos = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${dos(d.getMonth() + 1)}-${dos(d.getDate())}`;
}

export function llenarCampos(props_c, datos = null) {
  if (datos) {
    const ultima = datos?.estudiante_inscripcion[datos?.estudiante_inscripcion?.length - 1];
    props_c.setPrimer_nombre(datos?.primer_nombre || '')
    props_c.setSegundo_nombre(datos?.segundo_nombre || '')
    props_c.setPrimer_apellido(datos?.primer_apellido || '')
    props_c.setSegundo_apellido(datos?.segundo_apellido || '')
    props_c.setTipo_identificacion(datos?.tipo_identificacion && { value: datos?.tipo_identificacion?.id, label: datos?.tipo_identificacion?.nombre, codigo: datos?.tipo_identificacion?.codigo } || '')
    props_c.setTipo_identificacion_saber(datos?.tipo_identificacion && { value: datos?.tipo_identificacion?.id, label: datos?.tipo_identificacion?.nombre, codigo: datos?.tipo_identificacion?.codigo } || '')
    props_c.setTelefono1(ultima?.telefono1 || '')
    props_c.setCelular1(ultima?.celular1 || '')
    // Correo personal (el de la inscripción); el correo principal de la persona puede ser el institucional
    props_c.setCorreo(ultima?.correo || datos?.correo_personal || datos?.correo || '')
    // No se autollenan el paso 2 (residencia, estrato, EPS) ni el paso 3 (sede, programa, cómo nos conociste):
    // el aspirante los diligencia de nuevo porque pueden haber cambiado
    // Fecha de nacimiento en hora local ("2022-02-03" con new Date() se tomaría como UTC y mostraría el día anterior)
    const nacimiento = String(datos?.fecha_nacimiento || '').match(/^(\d{4})-(\d{2})-(\d{2})/);
    props_c.setFechaNacimiento(nacimiento ? new Date(+nacimiento[1], +nacimiento[2] - 1, +nacimiento[3]) : null)
    props_c.setGenero(datos?.genero && { value: datos?.genero?.id, label: datos?.genero?.nombre, codigo: datos?.genero?.codigo } || null)
    // El código se guarda con su prefijo ("VG 3233..."): se separa para no duplicarlo al guardar
    const codigoGuardado = String(ultima?.codigo_pruebas || '').trim();
    const partesCodigo = codigoGuardado.match(/^(AC|VG)\s*(\d+)$/i);
    if (partesCodigo) props_c.setPrefijoCodigo(partesCodigo[1].toUpperCase());
    props_c.setCodigo_pruebas(partesCodigo ? partesCodigo[2] : codigoGuardado.replace(/[^0-9]/g, ''))
    props_c.setPuntaje_pruebas(ultima?.puntaje_pruebas || '')
    props_c.setOpcion_sisben(ultima?.sisben && { value: ultima?.sisben, label: ultima?.sisben.toUpperCase() } || '')
    props_c.setPuntaje_sisben(datos?.puntaje_sisben || '')
    props_c.setGrupo(ultima?.grupo && { value: ultima?.grupo?.id, label: ultima?.grupo?.nombre, codigo: ultima?.grupo?.codigo } || '')
    props_c.setDiscapacidad(ultima?.discapacidad && { value: ultima?.discapacidad?.id, descripcion: ultima?.discapacidad?.descripcion, label: ultima?.discapacidad?.nombre, codigo: ultima?.discapacidad?.codigo } || '')
    // Los adjuntos no se autollenan: se deben cargar de nuevo en cada inscripción
    props_c.setAdj_identificacion('')
    props_c.setAdj_diploma('')
    props_c.setAdj_saber('')
    props_c.setAdj_certificado('')
    props_c.setAdj_docu_notas('')
  } else {
    props_c.setPrimer_nombre("")
    props_c.setSegundo_nombre("")
    props_c.setPrimer_apellido("")
    props_c.setSegundo_apellido("")
    props_c.setTelefono1("")
    props_c.setCelular1("")
    props_c.setCorreo("")
    props_c.setCodigo_pruebas("")
    props_c.setPuntaje_pruebas("")
    props_c.setOpcion_sisben("")
    props_c.setPuntaje_sisben("")
    props_c.setGrupo("")
    props_c.setDiscapacidad("")
    props_c.setAdj_identificacion("")
    props_c.setAdj_diploma("")
    props_c.setAdj_saber("")
    props_c.setAdj_certificado("")
    props_c.setDepartamento("")
    props_c.setCiudad("")
    props_c.setBarrio("")
    props_c.setDireccion("")
    props_c.setEstrato("")
    props_c.setOpcion_conociste("")
    props_c.setCarrera("")
    props_c.setAdj_docu_notas("")
    props_c.setNombreEps('')
    props_c.setNombreEpsOtro('')
  }
}

// setResultado recibe { mensaje, cargando } para el modal de validación.
// Se consulta con documento + fecha de expedición: el backend solo devuelve los datos para
// autollenar si la fecha coincide con la registrada (verificado). Si no, solo informa que la
// persona existe y el contacto del mentor.
export async function validarIdentificacion(identificacion, fechaExpedicion, props_c, setBotonSiguiente, setResultado) {
  let { actualizarMensaje, setMostrarBtn, mostrarModalMensajeValidacionId, mensaje } = props_c
  const fecha = formatoFecha(fechaExpedicion);
  if (!identificacion || !fecha) return;
  setResultado({ mensaje: '', cargando: true });
  mostrarModalMensajeValidacionId(true)
  let f = await generarFiltros([{ 'llave': 'identificacion', 'valor': identificacion }, { 'llave': 'fecha_expedicion', 'valor': fecha }]);
  consulta(`api/v1.0/inscripcion/validar_id?${f}`, null, null, (error, estado, resp) => {
    let titulo = 'Ha ocurrido un error, contacte con el administrador.', tipo = 'error';
    if (!error) {
      if (estado === 200) {
        if (resp.length > 0) {
          const inscripciones = resp[0]?.estudiante_inscripcion || [];
          const ultima = inscripciones[inscripciones.length - 1];
          if ([16880, 118].includes(ultima?.tipo)) {
            setMostrarBtn(true)
            llenarCampos(props_c)
            setBotonSiguiente(true)
            // El mentor (gestor) viene en la última inscripción, no en la persona
            const gestor = ultima?.gestor;
            let text = gestor
              ? `¡Tu cuenta ya está registrada en la plataforma. Para completar tu inscripción en la universidad, contacta a tu mentor al correo ${gestor.correo}${gestor.celular ? ` o al número ${gestor.celular}` : ''}!`
              : `¡Ya estás inscrito en la plataforma, comunícate vía WhatsApp con el número 3168569919!`;
            setResultado({ mensaje: text, cargando: false });
          } else if (resp[0]?.inscripcion_en_proceso) {
            // Aviso temprano: ya tiene una inscripción en curso en este periodo; no se deja continuar
            setMostrarBtn(true)
            setBotonSiguiente(true)
            setResultado({ mensaje: `Ya tienes una inscripción en proceso para este periodo. Si necesitas ayuda, ${mensaje}.`, cargando: false });
          } else if (resp[0]?.verificado) {
            setMostrarBtn(false)
            llenarCampos(props_c, resp[0])
            setBotonSiguiente(false)
            setResultado({ mensaje: `¡Ya estás registrado en nuestra plataforma! Para continuar: Revisa tus datos y actualizalos. ${mensaje}.`, cargando: false });
          } else {
            // Registrado pero sin verificar: no se autollena; se actualizará con lo que diligencie
            setMostrarBtn(false)
            setBotonSiguiente(false)
            setResultado({ mensaje: 'Ya estás registrado en nuestra plataforma. Completa tus datos para continuar; los actualizaremos con la información que ingreses.', cargando: false });
          }
        } else {
          setMostrarBtn(true)
          setBotonSiguiente(false)
          setResultado({ mensaje: `Tu identificación es válida para la inscripcion. Puedes continuar.`, cargando: false });
        }
      }
    } else {
      setBotonSiguiente(false)
      actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 })
    }
  }, false)
}
